module.exports = __webpack_public_path__ + "assets/bb8350b572a19f4e50b7928fd7ad1c2d.mp3";